import { Text } from '@/components/ui/text'
import { type NotificationType } from '@/redux/slices/notificationSlice'
import { router } from 'expo-router'
import ItemWrapper from './ItemWrapper'

// The `JiriRoutineRunActivity` fields GetNotifications.graphql asks for; spelled out here until
// src/typings/domain.ts is next regenerated against a goldendata that has routines.
type JiriRoutineRunActivity = {
  routineId?: string | null
  routineName?: string | null
  runId?: string | null
  conversationId?: string | null
  reason?: string | null
}

// nextfe `locales/zh-CN/notifications.json` `verb.jiri_routine_*`: `reason` means the failure for a failed run
// and the pause reason for a paused routine.
const REASONS: Record<string, Record<string, string>> = {
  jiri_routine_failed: {
    timeout: '执行超时',
    jiri_error: 'Jiri 执行出错',
    start_failed: '启动失败',
    content_rejected: '内容不合规',
    lost_access: '已失去关联对象的权限',
    invalid_trigger: '触发条件已失效',
    INSUFFICIENT_POINTS: 'AI 点数不足',
  },
  jiri_routine_paused: {
    failures: '连续失败 3 次',
    insufficient_points: 'AI 点数连续不足',
    lost_access: '已失去关联对象的权限',
    content_rejected: '内容不合规',
    completed: '一次性任务已执行',
    user: '手动暂停',
    invalid_trigger: '触发条件已失效',
  },
}

/**
 * A Jiri routine that failed a run, or paused itself (nextfe `JiriRoutineRun`). A failed run with a
 * conversation opens it in the Jiri chat; a routine's own pages exist only on the web.
 */
export default function JiriRoutineRun({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as JiriRoutineRunActivity | undefined
  if (!activity) return null
  const paused = notification.verb === 'jiri_routine_paused'
  const reason = activity.reason ? (REASONS[notification.verb]?.[activity.reason] ?? activity.reason) : undefined
  const conversationId = !paused ? activity.conversationId : undefined

  return (
    <ItemWrapper
      notification={notification}
      onPress={conversationId ? () => router.push({ pathname: '/jiri', params: { conversationId } }) : undefined}
    >
      自动任务「<Text className="font-bold">{activity.routineName ?? ''}</Text>」{paused ? '已暂停' : '执行失败'}
      {reason ? `：${reason}` : ''}
    </ItemWrapper>
  )
}
